var _defs, _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQsBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#1c7ce4;}.cls-1{opacity:0.1;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.23,32.65H12a2,2,0,0,1-2-2V23.18a2,2,0,0,1,2-2h2.19a2,2,0,0,1,2,2v7.47A2,2,0,0,1,14.23,32.65ZM12,23.18v7.47h2.19V23.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,32.65H27.77a2,2,0,0,1-2-2V16.58a2,2,0,0,1,2-2H30a2,2,0,0,1,2,2V30.65A2,2,0,0,1,30,32.65Zm0-2v0ZM27.77,16.58V30.65H30V16.58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.09,32.65H19.91a2,2,0,0,1-2-2V11.35a2,2,0,0,1,2-2h2.18a2,2,0,0,1,2,2v19.3A2,2,0,0,1,22.09,32.65Zm-2.18-21.3v19.3h2.18V11.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsBar);
export default __webpack_public_path__ + "static/media/qs-bar.c9cac855f70f946e1748ba5fa0bda6fd.svg";
export { ForwardRef as ReactComponent };